export type ServiceTheme = {
  hex: string;
  accentColor: string;
  accentBorder: string;
  accentBg: string;
  selection: string;
  breadcrumbActive: string;
  headerPrefix: string;
  sectionTitles: {
    capabilities: string;
    artifacts: string;
    protocol: string;
  };
};

export const getServiceTheme = (category: string): ServiceTheme => {
  switch (category) {
    case 'genai':
      return {
        hex: "#c084fc", // purple-400
        accentColor: "text-purple-400",
        accentBorder: "border-purple-500/20",
        accentBg: "bg-purple-500/10",
        selection: "selection:bg-purple-500/30",
        breadcrumbActive: "text-purple-400",
        headerPrefix: "///",
        sectionTitles: {
          capabilities: "MODEL_CAPABILITIES",
          artifacts: "NEURAL_ARCHITECTURE",
          protocol: "INFERENCE_PROTOCOL"
        }
      }
    case 'enterprise':
      return {
        hex: "#60a5fa", // blue-400
        accentColor: "text-blue-400",
        accentBorder: "border-blue-500/20",
        accentBg: "bg-blue-500/10",
        selection: "selection:bg-blue-500/30",
        breadcrumbActive: "text-blue-400",
        headerPrefix: "|",
        sectionTitles: {
          capabilities: "SECTOR_SOLUTIONS",
          artifacts: "ENTERPRISE_STACK",
          protocol: "SCALABILITY_MATRIX"
        }
      }
    case 'development':
      return {
        hex: "#34d399", // emerald-400
        accentColor: "text-emerald-400",
        accentBorder: "border-emerald-500/20",
        accentBg: "bg-emerald-500/10",
        selection: "selection:bg-emerald-500/30",
        breadcrumbActive: "text-emerald-400",
        headerPrefix: "<",
        sectionTitles: {
          capabilities: "BUILD_MODULES",
          artifacts: "TECH_STACK",
          protocol: "DEV_OPS_CYCLE"
        }
      }
    case 'blockchain':
    default:
      return {
        hex: "#22d3ee", // cyan-400
        accentColor: "text-cyan-400",
        accentBorder: "border-cyan-500/20",
        accentBg: "bg-cyan-500/10",
        selection: "selection:bg-cyan-500/30",
        breadcrumbActive: "text-cyan-400",
        headerPrefix: "//",
        sectionTitles: {
          capabilities: "CAPABILITIES_MATRIX",
          artifacts: "CORE_ARTIFACTS",
          protocol: "EXECUTION_PROTOCOL"
        }
      }
  }
}

